var map = {
	"./after_sign_up.json": 96843,
	"./book_a_class.json": 83806,
	"./book_a_course.json": 44455,
	"./chapter_details.json": 9684,
	"./class_banner.json": 90796,
	"./class_card.json": 72472,
	"./class_details.json": 82922,
	"./common.json": 35972,
	"./confirm_registration.json": 4079,
	"./error.json": 68496,
	"./login.json": 93606,
	"./my_billing.json": 91983,
	"./my_certificates.json": 92854,
	"./my_classes.json": 8073,
	"./my_credits.json": 12974,
	"./my_level.json": 11050,
	"./my_mailbox.json": 9951,
	"./my_profile.json": 53249,
	"./my_progress.json": 39367,
	"./my_settings.json": 88764,
	"./navbar.json": 10740,
	"./new_sign_up.json": 57863,
	"./rating.json": 99506,
	"./refer_a_friend.json": 48282,
	"./referral.json": 52492,
	"./registration.json": 5656,
	"./registration_survey.json": 82902,
	"./stripe.json": 51774,
	"./support.json": 69422,
	"./teacher_profile.json": 53038,
	"./topic_details.json": 8195,
	"locales/vi/after_sign_up.json": 96843,
	"locales/vi/book_a_class.json": 83806,
	"locales/vi/book_a_course.json": 44455,
	"locales/vi/chapter_details.json": 9684,
	"locales/vi/class_banner.json": 90796,
	"locales/vi/class_card.json": 72472,
	"locales/vi/class_details.json": 82922,
	"locales/vi/common.json": 35972,
	"locales/vi/confirm_registration.json": 4079,
	"locales/vi/error.json": 68496,
	"locales/vi/login.json": 93606,
	"locales/vi/my_billing.json": 91983,
	"locales/vi/my_certificates.json": 92854,
	"locales/vi/my_classes.json": 8073,
	"locales/vi/my_credits.json": 12974,
	"locales/vi/my_level.json": 11050,
	"locales/vi/my_mailbox.json": 9951,
	"locales/vi/my_profile.json": 53249,
	"locales/vi/my_progress.json": 39367,
	"locales/vi/my_settings.json": 88764,
	"locales/vi/navbar.json": 10740,
	"locales/vi/new_sign_up.json": 57863,
	"locales/vi/rating.json": 99506,
	"locales/vi/refer_a_friend.json": 48282,
	"locales/vi/referral.json": 52492,
	"locales/vi/registration.json": 5656,
	"locales/vi/registration_survey.json": 82902,
	"locales/vi/stripe.json": 51774,
	"locales/vi/support.json": 69422,
	"locales/vi/teacher_profile.json": 53038,
	"locales/vi/topic_details.json": 8195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54185;